module.exports = __webpack_public_path__ + "ce80cfcbe78e3a82c4ed6834b1554f41.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/svg/chevron_up.svg
// module id = 214
// module chunks = 0